import "core-js/modules/es.array.find-index";
import "core-js/modules/es.number.constructor"; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'VueJsDialog',
  props: {
    width: {
      type: [Number, String],
      "default": 400
    },
    clickToClose: {
      type: Boolean,
      "default": true
    },
    transition: {
      type: String,
      "default": 'fade'
    }
  },
  data: function data() {
    return {
      params: {},
      defaultButtons: [{
        title: 'CLOSE'
      }]
    };
  },
  computed: {
    buttons: function buttons() {
      return this.params.buttons || this.defaultButtons;
    },

    /**
      * Returns FLEX style with correct width for arbitrary number of
      * buttons.
      */
    buttonStyle: function buttonStyle() {
      return {
        flex: "1 1 ".concat(100 / this.buttons.length, "%")
      };
    }
  },
  methods: {
    beforeOpened: function beforeOpened(event) {
      window.addEventListener('keyup', this.onKeyUp);
      this.params = event.params || {};
      this.$emit('before-opened', event);
    },
    beforeClosed: function beforeClosed(event) {
      window.removeEventListener('keyup', this.onKeyUp);
      this.params = {};
      this.$emit('before-closed', event);
    },
    click: function click(i, event) {
      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'click';
      var button = this.buttons[i];

      if (button && typeof button.handler === 'function') {
        button.handler(i, event, {
          source: source
        });
      } else {
        this.$modal.hide('dialog');
      }
    },
    onKeyUp: function onKeyUp(event) {
      if (event.which === 13 && this.buttons.length > 0) {
        var buttonIndex = this.buttons.length === 1 ? 0 : this.buttons.findIndex(function (button) {
          return button["default"];
        });

        if (buttonIndex !== -1) {
          this.click(buttonIndex, event, 'keypress');
        }
      }
    }
  }
};